export const EMPTY_SINGLE_VALUE = '';
export const EMPTY_MULTI_VALUE = [];
